import script from "./sensor-card.vue?vue&type=script&setup=true&lang=js"
export * from "./sensor-card.vue?vue&type=script&setup=true&lang=js"

import "./sensor-card.vue?vue&type=style&index=0&id=526f02db&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526f02db"]])

export default __exports__